import { createRouter, createWebHashHistory } from 'vue-router';

// Определяем маршруты
const routes = [
    {
        name: 'index',
        path: '/',
        component: () => import('../components/WorkspaceComponent.vue')
    },
    {
        name: 'about',
        path: '/about',
        component: () => import('../components/AboutView.vue')
    },

    {
        name: 'GL',
        path: '/gl',
        component: () => import('../components/WebGLOrbits.vue')
    },
    {
        name: 'Orderbooks',
        path: '/orderbooks',
        component: () => import('../components/MarketWatchOrderbooks.vue')
    },


    {
        name: 'MatStat',
        path: '/matstat',
        component: () => import('../components/MatStat.vue')
    },
    {
        name: 'FuzzyLong',
        path: '/fuzzylong',
        component: () => import('../widgets/Fuzzy/TradingComponent.vue')
    },
    {
        name: 'FuzzyLogic',
        path: '/fuzzylogic',
        component: () => import('../components/FuzzyLogic.vue')
    },
    {
        name: 'FractalVectorPlus',
        path: '/fractalvectorplus',
        component: () => import('../components/FractalVectorPlus.vue')
    },
    {
        name: 'DynamicAnalyzerPlus',
        path: '/dynamicanalyzerplus',
        component: () => import('../components/DynamicAnalyzerPlus.vue')
    },

    {
        name: 'EventsTimeline',
        path: '/events',
        component: () => import('../components/EventsTimeline.vue')
    },

    {
        name: 'AnomalyDetector',
        path: '/anomaly',
        component: () => import('../components/AnomalyDetector.vue')
    },

    {
        name: 'hybridForecastRemote',
        path: '/distribution',
        component: () => import('../components/HybridForecastRemote.vue')
    },
    {
        name: 'hybridForecastParent',
        path: '/hybridforecast2',
        component: () => import('../components/HybridForecastParent.vue')
    },
    {
        name: 'hybridForecast',
        path: '/hybridforecast',
        component: () => import('../components/HybridForecast.vue')
    },
    {
        name: 'strengthCoeff',
        path: '/strengthcoeff',
        component: () => import('../components/StrengthCoeff.vue')
    },
    {
        name: 'geoDistance',
        path: '/geodistance',
        component: () => import('../components/GeoDistance.vue')
    },
    {
        name: 'dynamicAnalyzer',
        path: '/dynamicanalyzer',
        component: () => import('../components/DynamicAnalyzer.vue')
    },
    {
        name: 'calculator',
        path: '/calculator',
        component: () => import('../components/CalculatorPosition.vue')
    },
    {
        name: 'levels',
        path: '/levels',
        component: () => import('../components/MarketWatchLevels.vue')
    },
    {
        name: 'levelsexample',
        path: '/levelsexample',
        component: () => import('../components/LevelsExample.vue')
    },
    {
        name: 'fractalVector',
        path: '/fractalvector',
        component: () => import('../components/FractalVector.vue')
    },
    {
        name: 'candlesHistory',
        path: '/candleshistory',
        component: () => import('../components/CandlesHistory.vue')
    },
    {
        name: 'candlesCharts',
        path: '/candlescharts',
        component: () => import('../components/CandlesCharts.vue')
    },
    {
        name: 'candlesChart',
        path: '/candleschart',
        component: () => import('../components/CandlesChart.vue')
    },
    {
        name: 'multichart',
        path: '/multichart',
        component: () => import('../components/MultiChart.vue')
    },

    {
        name: 'candleStream',
        path: '/candlestream/:ticker',
        component: () => import('../components/CandlesChartStream.vue')
    },
    {
        name: 'candlesSeconds',
        path: '/candlesseconds/:ticker',
        component: () => import('../components/CandlesSeconds.vue')
    },

    {
        name: 'tradeStream',
        path: '/tradestream/:ticker',
        component: () => import('../components/TradesChartStream.vue')
    },
    {
        name: 'candlesFibonacci',
        path: '/candlesfibonacci/:ticker',
        component: () => import('../components/candlesFibonacci.vue')
    },
    {
        name: 'MarketWatch',
        path: '/marketwatch',
        component: () => import('../components/MarketWatch.vue')
    },

    {
        name: 'NodeGraph',
        path: '/nodegraph',
        component: () => import('../components/NodeGraph.vue')
    },
    {
        name: 'Terminal',
        path: '/terminal',
        component: () => import('../terminal/HybridTerminal.vue')
    },

    {
        name: 'Travel',
        path: '/travel',
        component: () => import('../genetic/TravelAlgo.vue')
    },
    {
        name: 'sparks',
        path: '/sparks',
        component: () => import('../genetic/sparks/SparksManager.vue')
    },
    {
        name: 'flocks',
        path: '/flocks',
        component: () => import('../genetic/flocks/FlockManager.vue')
    },
    {
        name: 'flocks2',
        path: '/flocks2',
        component: () => import('../genetic/FlocksAlgo.vue')
    },

    {
        name: 'hunters',
        path: '/hunters',
        component: () => import('../genetic/HuntersAlgo.vue')
    },

    {
        name: 'spin',
        path: '/spin',
        component: () => import('../genetic/SpinAlgo.vue')
    },


    {
        name: 'evofield',
        path: '/evofield',
        component: () => import('../AI/lab/EvoField.vue')
    },

    {
        name: 'lab',
        path: '/lab',
        component: () => import('../AI/lab5/AiLab.vue')
    },
    {
        name: 'metalab',
        path: '/metalab',
        component: () => import('../AI/lab-meta/MetaEvoLab.vue')
    },
    {
        name: 'live',
        path: '/live',
        component: () => import('../genetic/live/LiveView.vue')
    },
    {
        name: 'live2',
        path: '/live2',
        component: () => import('../genetic/live/ParentLive.vue')
    },

    {
        name: 'SignalFabric',
        path: '/signalfabric',
        component: () => import('../genetic/signalfabric/SignalFabric.vue')
    },

    {
        name: 'MarketPhase',
        path: '/phases',
        component: () => import('../components/MarketPhase.vue')
    },

    {
        name: 'MarketWatchSignals',
        path: '/signals',
        component: () => import('../components/MarketWatchSignals.vue')
    },

    {
        name: 'MarketWatchSignals2',
        path: '/signals2',
        component: () => import('../components/MarketWatchSignals2.vue')
    },

    {
        path: '/news',
        component: () => import('../components/NewsFeed.vue')
    },
    {
        path: '/voicehq',
        component: () => import('../components/VoiceHQ.vue')
    },
    {
        path: '/voicelq',
        component: () => import('../components/VoiceLQ.vue')
    },
    {
        path: '/chat',
        component: () => import('../widgets/ChatTemplate.vue')
    },
    {
        path: '/beacon2',
        component: () => import('../widgets/BeaconLanguage2.vue')
    },
    {
        path: '/beacon',
        component: () => import('../widgets/BeaconLanguage.vue')
    },
    {
        path: '/markov',
        component: () => import('../widgets/MarkovStockSimulation.vue')
    },
    {
        name: "meshbot",
        path: '/meshbot',
        component: () => import('../widgets/Meshbot/MeshbotManager.vue')
    },
    {
        path: '/meshbottemplate',
        component: () => import('../widgets/Meshbot/MeshbotTemplate.vue')
    },
    {
        name: 'MeshConfigurator',
        path: '/meshconfigurator',
        component: () => import('../widgets/Meshbot/components/MeshConfigurator.vue')
    },

    {
        name: 'tradesMoney',
        path: '/tradesmoney',
        component: () => import('../components/TradesMoney.vue')
    },
    {
        name: 'tradesList',
        path: '/trades',
        component: () => import('../components/TradesList.vue')
    },
    {
        path: '/grid',
        component: () => import('../components/WidgetGrid.vue')
    },
    {
        path: '/intervals',
        component: () => import('../widgets/IntervalsTemplate.vue')
    },
    {
        name: 'workspace',
        path: '/workspace',
        component: () => import('../components/WorkspaceComponent.vue')
    },
    {
        path: '/alororderbooks',
        component: () => import('../components/AlorOrderbooks.vue')
    },

    {
        path: '/alorcandles',
        component: () => import('../components/AlorCandles.vue')
    },
    {
        path: '/alorquotes',
        component: () => import('../components/AlorQuotes.vue')
    },
    {
        path: '/alortrades',
        component: () => import('../components/AlorTrades.vue')
    },
    {
        path: '/alortradesplus',
        component: () => import('../components/AlorTradesPlus.vue')
    },
    {
        path: '/tcscandles',
        component: () => import('../components/TcsCandles.vue')
    },
    {
        path: '/tcstrades',
        component: () => import('../components/TcsTrades.vue')
    },
];

// Создаем роутер
const router = createRouter({
    history: createWebHashHistory(), // Используем hash history
    routes,
});

// Экспортируем роутер
export default router;
